export class Thread {

  public static sleep (delay = 0): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, delay))
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/utils/thread.ts